

export default function IconLinux() {
  return (
    <img alt="linux" src="/images/linux.svg" />
  );
}
 